// extracted by mini-css-extract-plugin
export default {"ionToolBar":"Header_ionToolBar__coB7V","backButton":"Header_backButton__m8KVi","headerTitle":"Header_headerTitle__aBaGJ"};